import React from 'react'
import FormInput from '../../../../../components/forms/formInput';
import FormSelect from '../../../../../components/forms/formSelect';

const Varients = ({varients,setVarients,deliveryTypeList}) => {
    const width = window.innerWidth;

  const setIndexVSku = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.sku = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVPrice = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.price = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVCompareatprice = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.compareatprice = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVdeliverytype = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.deliverytype = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  const setIndexVCount = (i,val)=>{
    let sendlist = [];
    for (let index = 0; index < varients.length; index++) {
      const element = varients[index];
      if(i === index){
        element.count = val;
      }
      sendlist.push(element);
    }
    setVarients(sendlist);
  }
  return (
    <div className='listing_varient_container'>
    <div className='admin_forms_multirow'>
        {
          varients.map((varient,index)=>{
            return(
                <div className='admin_col_50' key={index} style={{
                    border:"1px solid #2a2a2a",
                    padding:"5px 10px",
                    borderRadius:"5px"
                }}>
                    <div className='admin_forms_row'>
                        <div className='admin_col_50'>
                            <FormInput Lable='Title' Type='text' Placeholder='' Value={varient.title} readonly={true}/>
                        </div>
                        <div className='admin_col_50'>
                        <FormInput Lable='Sku' Type='text' Placeholder='Enter SKU' Value={varient.sku} setValue={(e)=>{setIndexVSku(index,e)}}/>
                        </div>
                    </div>
                    <div className='admin_forms_row'>
                        <div className='admin_col_50'>
                        <FormInput Lable='Price' Type='number' Placeholder='Enter Price' Value={varient.price} setValue={(e)=>{setIndexVPrice(index,e)}}/>
                        </div>
                        <div className='admin_col_50'>
                        <FormInput Lable='Compare at Price' Type='number' Placeholder='Enter Compare at Price' Value={varient.compareatprice} setValue={(e)=>{setIndexVCompareatprice(index,e)}}/>
                        </div>
                    </div>
                    <div className='admin_forms_row'>
                        <div className='admin_col_50'>
                        <FormSelect Lable='Delivery' Value={varient.deliverytype} setValue={(e)=>{setIndexVdeliverytype(index,e)}} Options={deliveryTypeList}/>
                        </div>
                        <div className='admin_col_50'>
                        <FormInput Lable='Count' Type='number' Placeholder='Enter Count' Value={varient.count} setValue={(e)=>{setIndexVCount(index,e)}}/>
                        </div>
                    </div>
                </div>
            )
          })
        }
        </div>
    </div>
  )
}

export default Varients
